"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserType = exports.Status = exports.OktaRecoveryStatus = void 0;
var OktaRecoveryStatus;
(function (OktaRecoveryStatus) {
    OktaRecoveryStatus["MfaEnroll"] = "MFA_ENROLL";
    OktaRecoveryStatus["MfaRequired"] = "MFA_REQUIRED";
    OktaRecoveryStatus["PasswordReset"] = "PASSWORD_RESET";
    OktaRecoveryStatus["Recovery"] = "RECOVERY";
    OktaRecoveryStatus["RecoveryChallenge"] = "RECOVERY_CHALLENGE";
    OktaRecoveryStatus["Success"] = "SUCCESS";
})(OktaRecoveryStatus = exports.OktaRecoveryStatus || (exports.OktaRecoveryStatus = {}));
var Status;
(function (Status) {
    Status["MfaRequired"] = "MFA_REQUIRED";
    Status["Success"] = "SUCCESS";
})(Status = exports.Status || (exports.Status = {}));
var UserType;
(function (UserType) {
    UserType["Managed"] = "MANAGED";
    UserType["Real"] = "REAL";
})(UserType = exports.UserType || (exports.UserType = {}));
